const API_URL = process.env.REACT_APP_API_URL;

// Helper function to handle common fetch operations
const fetchWithAuth = async (url, options = {}) => {
  // Get the authentication token from localStorage
  const token = localStorage.getItem("token");

  // Set up headers with authentication
  const headers = {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  // Perform the fetch operation
  const response = await fetch(url, {
    ...options,
    headers,
  });

  // Handle non-OK responses
  if (!response.ok) {
    throw new Error(`API Error: ${response.statusText}`);
  }

  return response.json();
};

// Services API
export const fetchServices = async () => {
  return fetchWithAuth(`${API_URL}/services`);
};

export const getServiceById = async (id) => {
  return fetchWithAuth(`${API_URL}/services/${id}`);
};

export const createService = async (serviceData) => {
  return fetchWithAuth(`${API_URL}/services`, {
    method: "POST",
    body: JSON.stringify(serviceData),
  });
};

export const updateService = async (id, serviceData) => {
  return fetchWithAuth(`${API_URL}/services/${id}`, {
    method: "PUT",
    body: JSON.stringify(serviceData),
  });
};

export const deleteService = async (id) => {
  return fetchWithAuth(`${API_URL}/services/${id}`, {
    method: "DELETE",
  });
};
